import { AllReviewsFilters } from "./components/AllReviewsFilters";

import { DirectReportData } from "../../../../../api/services/defs/direct-reports";

const getUserBeingViewed = (userID, directReportsData?: DirectReportData) => {
	const viewedUser = directReportsData?.directReports?.find((directReport) => directReport._id !== userID);
	return viewedUser?._id || userID;
};

export const getFiltersForSearchService = (
	filters: AllReviewsFilters,
	searchTerm?: string,
	userID?: string,
	directReportsData?: DirectReportData
) => {
	const finalFilters = {};
	// We need to get a direct report from this user to handle permission on the review search service
	// Since for company reviews page, non admin manager can only see reviews from their direct reports.
	finalFilters["user_being_viewed"] = getUserBeingViewed(userID, directReportsData);

	if (filters?.employee) {
		finalFilters["subject_in"] = [filters.employee.id];
		finalFilters["user_being_viewed"] = filters.employee.id;
	}

	if (filters?.reviews360) {
		if (filters.reviews360 === "easyAddEnabled") {
			finalFilters["360_count_gt"] = 0;
		} else if (filters.reviews360 === "awaitingApproval") {
			finalFilters["awaiting_approval_count_gt"] = 0;
		}
	}

	if (filters?.status && filters.status.length > 0) {
		finalFilters["status_in"] = filters.status;
	}

	if (searchTerm) {
		finalFilters["name_re"] = searchTerm;
	}

	return finalFilters;
};
